<template>
  <a-form-item
    :align="'left'"
    v-bind="$attrs.formitem"
    :validateStatus="errors ? (errors.length ? 'error' : 'success') : ''"
    :help="errors"
  >
    <div class="date-selector-dropdowns-container">
      <a-select
        :style="{
          width: '32% !important',
          marginRight: '1%',
        }"
        v-model="innerValue.day"
        placeholder="Día"
        :size="size"
        show-search
      >
        <a-select-option
          v-for="day in 31"
          :key="String(day).padStart(2, '0')"
          :value="String(day).padStart(2, '0')"
          >{{ String(day).padStart(2, "0") }}</a-select-option
        >
      </a-select>
      <a-select
        :style="{
          width: '32% !important',
          marginRight: '1%',
        }"
        v-model="innerValue.month"
        placeholder="Mes"
        :size="size"
        show-search
      >
        <a-select-option
          v-for="month in 12"
          :key="String(month).padStart(2, '0')"
          :value="String(month).padStart(2, '0')"
          >{{ String(month).padStart(2, "0") }}</a-select-option
        >
      </a-select>
      <a-select
        :style="{ width: '32% !important' }"
        v-model="innerValue.year"
        placeholder="Año"
        :size="size"
        show-search
      >
        <a-select-option
          v-for="year in 100"
          :key="year"
          :value="new Date().getFullYear() - year"
          >{{ String(new Date().getFullYear() - year) }}</a-select-option
        >
      </a-select>
    </div>
  </a-form-item>
</template>
<script>
import moment from "moment-timezone";

export default {
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "large",
    },
  },
  data: () => ({
    innerValue: {
      day: undefined,
      month: undefined,
      year: undefined,
    },
  }),
  watch: {
    // Handles internal model changes.
    innerValue: {
      handler(newVal) {
        const { day, month, year } = newVal;
        const isValidDate = moment(
          `${year}-${month}-${day}`,
          "YYYY-MM-DD",
          true
        ).isValid();
        if (!isValidDate) {
          this.$emit("input", null);
          this.$emit("change", null);
          return;
        }
        const value = `${year}-${String(month).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;
        this.$emit("input", moment(value, "YYYY-MM-DD"));
        this.$emit("change", moment(value, "YYYY-MM-DD"));
      },
      deep: true,
    },
    value: {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return;
        if (typeof newVal === "string") {
          const dateParts = newVal.split("-");
          const dateObj = {};
          if (dateParts.length === 3) {
            dateObj.year = String(parseInt(dateParts[0], 10)).padStart(4, "0");
            dateObj.month = String(parseInt(dateParts[1], 10)).padStart(2, "0");
            dateObj.day = String(parseInt(dateParts[2], 10)).padStart(2, "0");
          }
          this.innerValue = {
            ...this.innerValue,
            ...dateObj,
          };
        } else {
          console.warn(
            "DateSelector: value prop must be a string in the format 'YYYY-MM-DD'"
          );
        }
      },
      immediate: true,
    },
  },
};
</script>
